/* Fuchsia Air — JavaScript natif, sans dépendance */
(() => {
  'use strict';
  const T = window.theme || { routes: {}, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  if (T.animations && !reduced) document.documentElement.classList.add('anim');

  /* ---------- Apparition au scroll (fondu uniquement) ---------- */
  let io;
  function initReveal(root = document) {
    const els = $$('[data-reveal]:not(.is-visible)', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || designMode || reduced || !T.animations) { els.forEach(e => e.classList.add('is-visible')); return; }
    io = io || new IntersectionObserver((entries) => entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e, i) => { e.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(e); });
  }

  /* ---------- Barre d'annonce rotative ---------- */
  function initRotators(root = document) {
    $$('[data-rotator]', root).forEach(el => {
      if (el._init) return; el._init = true;
      const msgs = $$('.announce__msg', el); if (msgs.length < 2 || reduced) return;
      let i = 0; setInterval(() => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, +el.dataset.interval || 5000);
    });
  }

  /* ---------- Menu mobile & recherche ---------- */
  function toggleMenu(open) {
    const m = $('[data-menu]'); if (!m) return;
    const was = !m.hidden; m.hidden = !open; document.body.style.overflow = open ? 'hidden' : '';
    const b = $('[data-menu-open]'); if (b) b.setAttribute('aria-expanded', open);
    if (open) $('.mobile-menu__head .icon-btn', m)?.focus(); else if (was && b) b.focus({ preventScroll: true });
  }
  function toggleSearch(open) {
    const s = $('[data-search]'); if (!s) return; s.hidden = !open;
    if (!open) { const out = $('[data-search-results]', s); if (out) { out.hidden = true; out.innerHTML = ''; } }
    if (open) $('[data-search-input]', s)?.focus();
  }

  /* ---------- Panier (tiroir + AJAX) ---------- */
  const drawerEl = () => $('[data-drawer]');
  function openDrawer() { const d = drawerEl(); if (!d) return false; d.hidden = false; document.body.style.overflow = 'hidden'; $('.drawer__head .icon-btn', d)?.focus(); return true; }
  function closeDrawer() { const d = drawerEl(); if (!d) return; d.hidden = true; document.body.style.overflow = ''; }
  function setCount(n) {
    $$('[data-cart-count]').forEach(c => { c.textContent = n; c.hidden = !(n > 0); c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });
  }
  async function refreshDrawer() {
    try {
      const r = await fetch(`${T.routes.root}?sections=cart-drawer`); const j = await r.json();
      const doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
      const fresh = $('[data-drawer-inner]', doc), cur = $('[data-drawer-inner]');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; setCount(+fresh.dataset.count || 0); }
    } catch (e) { /* silencieux */ }
  }
  async function changeLine(line, quantity) {
    const row = $(`[data-line="${line}"]`)?.closest('[data-line-row]'); row?.classList.add('is-loading');
    try {
      const r = await fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +line, quantity: +quantity }) });
      const cart = await r.json();
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      setCount(cart.item_count); await refreshDrawer();
    } catch (e) { row?.classList.remove('is-loading'); }
  }
  async function addToCart(form) {
    const btn = $('[data-atc]', form), err = $('[data-form-error]', form); if (err) err.hidden = true;
    const label = $('[data-atc-label]', btn) || btn; const old = label.textContent;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      await refreshDrawer();
      if (!openDrawer()) location.href = T.routes.cart;
    } catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } }
    finally { btn.disabled = false; btn.removeAttribute('aria-busy'); label.textContent = old; }
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(root = document) {
    $$('[data-product]', root).forEach(sec => {
      if (sec._init) return; sec._init = true;
      const jsonEl = $('[data-product-json]', sec); const gallery = initGallery($('[data-gallery]', sec)); if (!jsonEl) return;
      let variants; try { variants = JSON.parse(jsonEl.textContent).variants; } catch (e) { console.error('[theme] variantes illisibles', e); return; }
      const form = $('[data-product-form]', sec), idInput = $('[data-variant-id]', sec);
      const low = +sec.dataset.lowStock || 0;
      const atc = $('[data-main-atc]', sec), atcLabel = $('[data-atc-label]', sec), stockEl = $('[data-stock]', sec);
      const priceBox = $('.pdp__price', sec);
      const sticky = $('[data-sticky-atc]', sec), stickyBtn = $('[data-sticky-btn]', sec), stickyPrice = $('[data-sticky-price]', sec);

      const selected = () => $$('[data-opt]:checked', sec).sort((a, b) => a.dataset.opt - b.dataset.opt).map(i => i.value);
      function update() {
        const sel = selected();
        $$('[data-opt]', sec).forEach(i => { // marque les combinaisons indisponibles
          const test = sel.slice(); test[+i.dataset.opt] = i.value;
          const v = variants.find(v => v.options.every((o, k) => o === test[k]));
          i.classList.toggle('is-unavailable', !v || !v.available);
        });
        $$('[data-opt-label]', sec).forEach(l => { l.textContent = sel[+l.dataset.optLabel] || ''; });
        const v = variants.find(v => v.options.every((o, k) => o === sel[k]));
        if (!v) { atc.disabled = true; atcLabel.textContent = T.strings.unavailable; if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = T.strings.unavailable; } return; }
        idInput.value = v.id;
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        atc.disabled = !v.available; atcLabel.textContent = v.available ? T.strings.adding : T.strings.soldOut;
        if (priceBox) {
          const now = $('[data-price]', priceBox), was = $('[data-compare]', priceBox), save = $('[data-save]', priceBox), sale = v.compare_raw > v.price_raw;
          now.textContent = v.price; priceBox.firstElementChild.classList.toggle('price--sale', sale);
          if (was) { was.hidden = !sale; was.textContent = sale ? v.compare : ''; }
          if (save) { save.hidden = !sale; save.textContent = sale ? '-' + Math.round((v.compare_raw - v.price_raw) * 100 / v.compare_raw) + '%' : ''; }
          $('.price__from', priceBox)?.remove();
        }
        if (stickyPrice) stickyPrice.textContent = v.price;
        if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? T.strings.adding : T.strings.soldOut; }
        if (stockEl) { const show = v.available && low > 0 && v.stock > 0 && v.stock <= low; stockEl.hidden = !show; if (show) stockEl.textContent = T.strings.lowStock.replace('__COUNT__', v.stock); }
        const sku = $('[data-sku]', sec); if (sku && v.sku) sku.textContent = v.sku;
        if (v.media && gallery) gallery.goTo(v.media);
      }
      $$('[data-opt]', sec).forEach(i => i.addEventListener('change', update));
      update();

      // quantité
      $$('[data-pdp-qty]', sec).forEach(b => b.addEventListener('click', () => { const q = $('[data-qty-input]', sec); q.value = Math.max(1, (+q.value || 1) + +b.dataset.pdpQty); }));

      // barre d'achat fixe
      if (sticky && 'IntersectionObserver' in window) {
        sticky.hidden = false;
        new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(atc);
        stickyBtn?.addEventListener('click', () => { if (!stickyBtn.disabled) form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    });
  }

  function initGallery(g) {
    if (!g) return null;
    if (g._api) return g._api;
    const track = $('[data-gallery-track]', g); if (!track) return null;
    const slides = $$('.gallery__item', g), thumbs = $$('[data-thumb]', g), dots = $$('.gallery__dots i', g);
    const setActive = i => { thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); };
    // photo la plus proche du centre de la zone visible
    const current = () => {
      const mid = track.scrollLeft + track.clientWidth / 2; let best = 0, gap = Infinity;
      slides.forEach((s, k) => { const d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid); if (d < gap) { gap = d; best = k; } });
      return best;
    };
    const goTo = id => { const i = slides.findIndex(m => m.dataset.mediaId == id); if (i < 0) return; track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced ? 'auto' : 'smooth' }); setActive(i); };
    const sync = () => setActive(current());
    thumbs.forEach(t => t.addEventListener('click', () => goTo(t.dataset.thumb)));
    let raf; const onScroll = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); };
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('scrollend', sync);
    addEventListener('resize', onScroll, { passive: true });
    sync();
    // zoom au survol (ordinateur)
    slides.forEach(it => {
      const img = $('img', it); if (!img) return;
      it.addEventListener('click', () => { if (matchMedia('(min-width: 990px)').matches) it.classList.toggle('is-zoom'); });
      it.addEventListener('mousemove', e => { const r = it.getBoundingClientRect(); it.style.setProperty('--ox', ((e.clientX - r.left) / r.width * 100) + '%'); it.style.setProperty('--oy', ((e.clientY - r.top) / r.height * 100) + '%'); });
      it.addEventListener('mouseleave', () => it.classList.remove('is-zoom'));
    });
    return (g._api = { goTo });
  }
  function initGalleries(root = document) { $$('[data-gallery]', root).forEach(g => initGallery(g)); }

  /* ---------- Sélecteur de réglages ---------- */
  function initModes(root = document) {
    $$('[data-modes]', root).forEach(m => {
      if (m._init) return; m._init = true;
      const tabs = $$('[data-tab]', m), panels = $$('[data-panel]', m), ring = $('.modes__ring', m);
      const select = i => {
        tabs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
        panels.forEach((p, k) => p.classList.toggle('is-active', k === i));
        ring.style.setProperty('--ring', tabs[i].style.getPropertyValue('--mode'));
      };
      tabs.forEach((t, i) => { t.addEventListener('click', () => select(i)); t.addEventListener('mouseenter', () => matchMedia('(hover:hover)').matches && select(i)); });
      select(0);
    });
  }

  /* ---------- Points d'annotation ---------- */
  function initHotspots(root = document) {
    $$('[data-hotspots]', root).forEach(h => {
      if (h._init) return; h._init = true;
      h.addEventListener('click', e => {
        const dot = e.target.closest('.hotspot__dot'); const cur = dot?.parentElement;
        $$('.hotspot.is-open', h).forEach(s => { if (s !== cur) { s.classList.remove('is-open'); $('.hotspot__dot', s).setAttribute('aria-expanded', 'false'); } });
        if (cur) { const open = cur.classList.toggle('is-open'); dot.setAttribute('aria-expanded', open); }
      });
    });
  }

  /* ---------- Recommandations ---------- */
  function initRecs(root = document) {
    $$('[data-recs]', root).forEach(el => {
      if (el._init || !el.dataset.url) return; el._init = true;
      fetch(el.dataset.url).then(r => r.text()).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html'), fresh = $('[data-recs]', doc);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); }
      }).catch(() => {});
    });
  }

  /* ---------- Recherche prédictive ---------- */
  function initSearch(root = document) {
    $$('[data-search-form]', root).forEach(form => {
      if (form._init) return; form._init = true;
      const input = $('[data-search-input]', form), out = $('[data-search-results]', form.closest('[data-search]'));
      if (!input || !out) return;
      let timer, ctrl;
      const clear = () => { out.hidden = true; out.innerHTML = ''; };
      async function run() {
        const q = input.value.trim();
        if (q.length < 2 || !T.routes.predictive) { clear(); return; }
        if (ctrl) ctrl.abort(); ctrl = new AbortController();
        try {
          const url = `${T.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,page,article&resources[limit]=4&resources[limit_scope]=each`;
          const r = await fetch(url, { signal: ctrl.signal }); if (!r.ok) throw new Error('search');
          const doc = new DOMParser().parseFromString(await r.text(), 'text/html'), res = $('[data-ps-root]', doc);
          if (res) { out.innerHTML = res.innerHTML; out.hidden = false; } else clear();
        } catch (e) { if (e.name !== 'AbortError') clear(); }
      }
      input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 220); });
      input.addEventListener('keydown', e => { if (e.key === 'ArrowDown') { const a = $('a', out); if (a) { e.preventDefault(); a.focus(); } } });
      out.addEventListener('keydown', e => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        const links = $$('a', out), i = links.indexOf(document.activeElement); if (i < 0) return;
        e.preventDefault(); (links[i + (e.key === 'ArrowDown' ? 1 : -1)] || input).focus();
      });
    });
  }

  /* ---------- Curseur avant / après ---------- */
  function initCompare(root = document) {
    $$('[data-ba]', root).forEach(ba => {
      if (ba._init) return; ba._init = true;
      const r = $('[data-ba-range]', ba); if (!r) return;
      const set = () => ba.style.setProperty('--pos', r.value + '%');
      r.addEventListener('input', set); set();
    });
  }

  /* ---------- Événements globaux (délégation) ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-menu-open]')) toggleMenu(true);
    else if (t.closest('[data-menu-close]')) toggleMenu(false);
    else if (t.closest('[data-menu] a')) toggleMenu(false);
    else if (t.closest('[data-search-open]')) toggleSearch(true);
    else if (t.closest('[data-search-close]')) toggleSearch(false);
    else if (t.closest('[data-drawer-close]')) closeDrawer();
    else if (t.closest('[data-cart-link]') && T.cartType === 'drawer' && drawerEl() && !document.body.classList.contains('template-cart')) { e.preventDefault(); refreshDrawer().then(openDrawer); }
    const qb = t.closest('[data-qty-btn]');
    if (qb) { const input = $(`[data-line-qty][data-line="${qb.dataset.line}"]`); changeLine(qb.dataset.line, Math.max(0, +input.value + +qb.dataset.qtyBtn)); }
    const rm = t.closest('[data-remove]'); if (rm) changeLine(rm.dataset.line, 0);
    if (t.closest('[data-toggle-recover]')) { e.preventDefault(); $('#login').hidden = true; $('#recover').hidden = false; }
    if (t.closest('[data-toggle-login]')) { e.preventDefault(); $('#recover').hidden = true; $('#login').hidden = false; }
  });
  document.addEventListener('change', e => {
    const li = e.target.closest('[data-line-qty]'); if (li) changeLine(li.dataset.line, Math.max(0, +li.value || 0));
    if (e.target.matches('[data-sort]')) e.target.form.submit();
  });
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-product-form]');
    if (f && T.cartType === 'drawer' && drawerEl()) { e.preventDefault(); addToCart(f); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); toggleMenu(false); toggleSearch(false); } });

  /* ---------- Initialisation ---------- */
  function initAll(root = document) {
    // chaque bloc est isolé : une erreur dans l'un n'empêche jamais les autres de fonctionner
    [initReveal, initRotators, initProduct, initGalleries, initModes, initHotspots, initRecs, initSearch, initCompare].forEach(f => { try { f(root); } catch (e) { console.error('[theme]', f.name, e); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
